import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../../utils/axiosClient";
import {
  urlListarValoresAgendamento,
  urlAtualizarValoresAgendamento,
} from "../../../utils/constants";
import MenuSide from "../../../components/empresas/MenuSide";
import {
  IonButton,
  IonItem,
  IonLabel,
  IonPage,
  IonContent,
  IonInput,
  IonList,
  IonSelect,
  IonSelectOption,
  IonToast
} from "@ionic/react";
import HeaderApp from "../../../components/global/HeaderItem";
import moment from "moment";

export default function ServicosEmpresas() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const dataValor = urlParams.get("dataAtualizar");

  const [itens, setItens] = useState([]);
  const [sucess, setSucess] = useState(false);

  const consultar = async () => {
    try {
      const response = await axiosClient.post(urlListarValoresAgendamento, {
        data_valor: dataValor,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const atualizar = async (agendamento) => {
    try {
      await axiosClient.post(urlAtualizarValoresAgendamento, {
        data_finalizacao: agendamento.data_agendamento,
        valor_finalizacao: agendamento.valor,
        status_finalizacao: agendamento.status,
        id: agendamento.id,
      });
    } catch (error) {
      return null;
    }
  };

  const atualizarTodos = async () => {
    for (const item of itens) {
      await atualizar(item);
    }
    setSucess(true);
  };

  const consultarItens = async () => {
    const lista = await consultar();
    setItens(lista);
  };

  const handleChange = (id, field, value) => {
    setItens((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  };

  useEffect(() => {
    consultarItens();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage id="main-content">
      <IonContent>
        <div className="ion-text-center ion-margin">
            <h4>Atualizar valores</h4>
        </div>
        {Array.isArray(itens) && (
          <div>
            <IonList>
              {itens.map((row, index) => (
                <IonItem key={index}>
                  <h5
                    style={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                    }}
                  >
                    {moment("2023-01-01 " + row.horario_inicial).format(
                      "HH:mm"
                    )}{" "}
                    -{" "}
                    {moment("2023-01-01 " + row.horario_final).format("HH:mm")} - Nº{row.id}
                  </h5>
                  <h5>Serviço: {row.servico}</h5>
                  <h5>Cliente: {row.cliente_nome}</h5>
                  <p
                    style={{
                      marginTop: "7px",
                      marginBottom: "5px",
                    }}
                  >
                    <i className="ri-information-line"></i> &nbsp; {row.obs}
                  </p>
                  <div style={{ width: "100%", marginTop: 8 }}>
                    <IonLabel position="stacked">Data</IonLabel>
                    <IonInput
                      type="date"
                      value={row.data_agendamento}
                      onIonChange={(e) =>
                        handleChange(row.id, "data_agendamento", e.detail.value)
                      }
                    />
                    <IonLabel position="stacked">Valor</IonLabel>
                    <IonInput
                      type="number"
                      value={row.valor}
                      onIonChange={(e) =>
                        handleChange(row.id, "valor", e.detail.value)
                      }
                    />
                    <IonLabel position="stacked">Status</IonLabel>
                    <IonSelect
                      value={row.status}
                      placeholder="Selecione o status"
                      onIonChange={(e) =>
                        handleChange(row.id, "status", e.detail.value)
                      }
                    >
                      <IonSelectOption value={1}>
                        Cliente compareceu
                      </IonSelectOption>
                      <IonSelectOption value={2}>
                        Cliente não compareceu
                      </IonSelectOption>
                    </IonSelect>
                  </div>
                   <div>------------------------------------</div>
                </IonItem>
               
              ))}
            </IonList>
            <IonButton
              expand="block"
              color="primary"
              onClick={atualizarTodos}
              style={{ marginTop: 16 }}
            >
              Atualizar Todos
            </IonButton>
          </div>
        )}
        <IonToast
          isOpen={sucess}
          color={'success'}
          icon="alert-outline"
          message="Valores validados com sucesso!"
          duration={5000}
        ></IonToast>
      </IonContent>
    </IonPage>
  );
}
